<label tabindex="0">
    <input 
    #radio
    [class.dark]="dark"
    type="radio" 
    [value]="value"
    [disabled]="disabled"
    [checked]="checked"
    />
    <span [class.dark]="dark" [class.disabled]="disabled">{{ label }}</span>  
</label>